import { Type } from '@angular/core';
import { SharedEffects } from './shared.effect';
import { AccessRequestRejectEffects } from './access-request-reject.effect';

export const effects: Type<object>[] = [
    SharedEffects,
    AccessRequestRejectEffects
];

export * from './shared.effect';
